import * as React from "react"
import { Box } from "@mui/material";
import { NotAllowedBlock } from "@components";


export default function stringColumn(name, label, visibility) {
	return [{
		name: name, label: label,
		options: {
			filter: false,
			display: visibility,
			setCellHeaderProps: () => ({ sx: { minWidth: 60 }}),
			customBodyRowRender: value => (
				<Box sx={ {textAlign:'center'} }>
                    {!!value ? value : <NotAllowedBlock />}
				</Box>
			)
		}
	}]
}
